import { format, parseISO } from "date-fns";
import { id as localeId } from "date-fns/locale";

export const formatDateID = (value, pattern = "d MMM yyyy") => {
  try {
    return format(typeof value === "string" ? parseISO(value) : value, pattern, { locale: localeId });
  } catch {
    return String(value ?? "");
  }
};

export const formatBytes = (bytes) => {
  if (!bytes) return "0 KB";
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
};

export const formatPhone = (phone) => (phone ? (phone.startsWith("62") ? `0${phone.slice(2)}` : phone) : "");

export { localeId };
